import { ID_OPPOSITION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-opposition';
import { ID_PUBBLICATIONS } from 'civil-status/components/step/form/last-step/accordions/section/list/list-publication';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { ID_OTHER_RITUAL_RELIGIOUS } from 'civil-status/constants/id-ritual-religious';
import { MatrimonioAtti, ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerMatrimonioAtti = (
  idEvento?: number,
  dataSection?: SectionVM,
  dataPubblicazioneList?: SectionVM,
  testoDelegaMatrimonio?: SectionVM,
  subjectOfficiante?: ParentVM,
  subjectSegrCiv?: ParentVM,
  subjectSposo?: ParentVM,
  subjectSposa?: ParentVM,
  subjectOfficianteTras?: ParentVM
): MatrimonioAtti | undefined => {
  if (
    !(
      dataSection ||
      dataPubblicazioneList ||
      testoDelegaMatrimonio ||
      subjectOfficiante ||
      subjectSegrCiv ||
      subjectSposo ||
      subjectSposa ||
      subjectOfficianteTras
    )
  ) {
    return undefined;
  }

  const isOtherMunicipality =
    dataSection?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

  return {
    key: {
      idEvento,
    },
    dataEvento: dataSection?.dateEvent ? dataSection.dateEvent?.toFormat('yyyy-MM-dd') : undefined,
    oraEvento: dataSection?.timeEvent
      ? Number.parseInt(dataSection?.timeEvent.toFormat('HH'), 10)
      : undefined,
    minutoEvento: dataSection?.timeEvent
      ? Number.parseInt(dataSection?.timeEvent.toFormat('mm'), 10)
      : undefined,
    numeroTestimoni: dataSection?.numberWitnesses
      ? Number.parseInt(dataSection?.numberWitnesses, 10)
      : undefined,
    flagRigettoOpposizione: dataSection
      ? dataSection?.opposition === ID_OPPOSITION.ID_DECRETO
        ? '1'
        : '0'
      : undefined,
    flagEstintaOpposizione: dataSection
      ? dataSection?.opposition === ID_OPPOSITION.ID_PROVVEDIMENTO
        ? '1'
        : '0'
      : undefined,
    tipoDifettoEta: dataSection?.ageDefect || undefined,
    tipoImpedimentoParentela: dataSection?.relationship || undefined,
    flagDivietoTemporaneo: dataSection
      ? dataSection.isTemporaryBanRemarriage
        ? '1'
        : '0'
      : undefined,
    flagPiuPubblicazioni: dataSection
      ? dataSection.publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OCCURRED
        ? '1'
        : '0'
      : undefined,
    flagOmissionePubblicazione: dataSection
      ? dataSection.publication === ID_PUBBLICATIONS.ID_PUBBLICATION_OMISSION
        ? '1'
        : '0'
      : undefined,
    flagRiduzTerminiPubblicaz: dataPubblicazioneList
      ? dataPubblicazioneList.isReductionTerms
        ? '1'
        : '0'
      : undefined,
    tipoAssistenteSposo: dataSection?.minorGroomAssistance || undefined,
    tipoAssistenteSposa: dataSection?.minorWifeAssistance || undefined,
    dataDelega: dataSection?.dataDelegate
      ? dataSection?.dataDelegate?.toFormat('yyyy-MM-dd')
      : undefined,
    testoDelega: testoDelegaMatrimonio?.actComposition || undefined,
    idNazioneDelegante: dataSection?.italianDelegating?.municipality?.code?.toString()
      ? ID_ITALIAN_NATION
      : Number.parseInt(dataSection?.foreignDelegating?.state?.code || '', 10),
    nomeNazioneDelegante: dataSection?.italianDelegating?.municipality?.code?.toString()
      ? DESCRIPTION_ITALIAN_NATION
      : dataSection?.foreignDelegating?.state?.value,
    idConsolatoDelegante: dataSection?.foreignDelegating?.consulate?.id?.toString()
      ? Number.parseInt(dataSection.foreignDelegating?.consulate?.id?.toString(), 10)
      : undefined,
    nomeConsolatoDelegante: dataSection?.foreignDelegating?.consulate?.value || undefined,
    idComuneDelegante: dataSection?.italianDelegating?.municipality?.code?.toString()
      ? Number.parseInt(dataSection?.italianDelegating?.municipality?.code.toString(), 10)
      : undefined,
    nomeComuneDelegante: isOtherMunicipality
      ? dataSection?.italianDelegating?.otherMunicipality || undefined
      : dataSection?.italianDelegating?.municipality?.description,
    idProvinciaDelegante: dataSection?.italianDelegating?.municipality?.idProvince || undefined,
    siglaProvinciaDelegante: dataSection?.italianDelegating?.municipality?.province || undefined,
    tipoSoggettoConImpedimento: dataSection?.impedimentUnitedCivilly || undefined,
    descrizioneRitoReligioso:
      dataSection?.configuration === ConfigurationType.MADTSP9
        ? 'Cattolico'
        : dataSection?.ritualReligious?.id?.toString() === ID_OTHER_RITUAL_RELIGIOUS
        ? dataSection?.otherRitualReligious
        : dataSection?.ritualReligious?.value || undefined,
    tipoDichiarMatrReligioso: dataSection?.declarant || undefined,
    flagRitoRiconosciuto:
      dataSection?.configuration === ConfigurationType.MADTSP9
        ? '1'
        : dataSection
        ? dataSection.isRecognizedRite
          ? '1'
          : '0'
        : undefined,
    tipoOfficiante:
      subjectOfficiante?.configuration === ConfigurationType.OFFI_ACATT
        ? '10'
        : subjectOfficiante?.generality?.ufcDelegate || undefined,
    tyOfficianteTrasmisAtto: subjectOfficianteTras?.generality?.ufcDelegate || undefined,
    tipoRuoloSegretario: subjectSegrCiv?.generality?.roloSecretary || undefined,
    tipoComprensioneSposo: subjectSposo?.generality?.conditionsItem?.id?.toString() || undefined,
    descrizioneImpedimScritturaSposo: subjectSposo?.generality?.reasonImpediment || undefined,
    tipoComprensioneSposa: subjectSposa?.generality?.conditionsItem?.id?.toString() || undefined,
    descrizioneImpedimScritturaSposa: subjectSposa?.generality?.reasonImpediment || undefined,
    flagSposoInPericoloVita: subjectSposo
      ? subjectSposo?.generality?.isImminentDangerOfLife
        ? '1'
        : '0'
      : undefined,
    descrizioneAccertamVolontaSposo: subjectSposo
      ? subjectSposo?.generality?.isImminentDangerOfLife
        ? subjectSposo?.generality?.verificationOfWill
        : ''
      : undefined,
    flagSposaInPericoloVita: subjectSposa
      ? subjectSposa?.generality?.isImminentDangerOfLife
        ? '1'
        : '0'
      : undefined,
    descrizioneAccertamVolontaSposa: subjectSposa
      ? subjectSposa?.generality?.isImminentDangerOfLife
        ? subjectSposa?.generality?.verificationOfWill
        : ''
      : undefined,
  };
};
